export {
    ACTIVITY_COPY_CAMERA_TEXTS,
    ActivityCopyCamera,
    type ActivityCopyCameraFailure,
    type ActivityCopyCameraPhase,
    type ActivityCopyCameraProps,
} from "./ActivityCopyCamera"
